import { AutoAwesome, Groups, MenuBook, VolunteerActivism } from "@mui/icons-material";
import React, { Fragment } from "react";
import { useNavigate } from "react-router-dom";

const GOLD = "#ffc000";
const PRIMARY = "#000c66";

const BG = "https://res.cloudinary.com/dsywsrg4f/image/upload/v1664831540/salvation/member_f1hapf.png";

const features = [
  {
    icon: <MenuBook style={{ color: GOLD, fontSize: 28 }} />,
    title: "Spiritual Growth",
    desc: "Deepen your faith through prayer, worship, and the living Word of God.",
  },
  {
    icon: <Groups style={{ color: GOLD, fontSize: 28 }} />,
    title: "True Fellowship",
    desc: "Connect with a warm, welcoming community of believers who truly care.",
  },
  {
    icon: <VolunteerActivism style={{ color: GOLD, fontSize: 28 }} />,
    title: "Purpose & Service",
    desc: "Discover your God-given calling and serve with passion in His vineyard.",
  },
];

export const Member = () => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <section
        style={{
          backgroundImage: `url(${BG})`,
          backgroundAttachment: "fixed",
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
        }}
      >
        {/* Dark overlay */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(160deg, rgba(0,12,102,0.94) 0%, rgba(0,0,0,0.88) 100%)",
          }}
        />

        {/* Content */}
        <div
          style={{ position: "relative", zIndex: 1 }}
          className="px-4 py-20 md:py-28 lg:py-32 flex flex-col items-center text-center"
        >
          {/* Eyebrow */}
          <div className="flex items-center gap-3 mb-4">
            <div className="h-px w-10" style={{ background: `${GOLD}88` }} />
            <p
              className="font-abel uppercase tracking-[0.4em] text-xs"
              style={{ color: GOLD }}
            >
              Join Our Community
            </p>
            <div className="h-px w-10" style={{ background: `${GOLD}88` }} />
          </div>

          {/* Headline */}
          <h2
            className="font-aref font-bold text-white text-3xl md:text-5xl leading-tight max-w-2xl"
          >
            Become a Part of Our{" "}
            <span style={{ color: GOLD }}>Amazing Family</span>
          </h2>

          {/* Subtext */}
          <p
            className="font-abel text-base md:text-lg mt-5 max-w-xl leading-relaxed"
            style={{ color: "rgba(255,255,255,0.72)" }}
          >
            We warmly welcome all who seek God's presence. At CCC Salvation
            Parish, you are not just a visitor — you are family. Step in, belong,
            and grow.
          </p>

          {/* Gold divider */}
          <div
            className="my-8 h-0.5 w-16"
            style={{ background: `linear-gradient(90deg, transparent, ${GOLD}, transparent)` }}
          />

          {/* Feature cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 w-full max-w-3xl mb-10">
            {features.map((f) => (
              <div
                key={f.title}
                className="flex flex-col items-center gap-3 px-5 py-6 rounded-xl"
                style={{
                  background: "rgba(255,255,255,0.05)",
                  border: `1px solid ${GOLD}30`,
                  backdropFilter: "blur(4px)",
                }}
              >
                <div
                  className="w-12 h-12 rounded-full flex items-center justify-center"
                  style={{ background: `${GOLD}18`, border: `1px solid ${GOLD}44` }}
                >
                  {f.icon}
                </div>
                <p
                  className="font-aref font-bold text-white text-base"
                >
                  {f.title}
                </p>
                <p
                  className="font-abel text-sm leading-relaxed"
                  style={{ color: "rgba(255,255,255,0.6)" }}
                >
                  {f.desc}
                </p>
              </div>
            ))}
          </div>

          {/* CTA button */}
          <button
            onClick={() => navigate("/join")}
            className="flex items-center gap-2 font-abel font-bold uppercase tracking-widest text-sm px-10 py-4 rounded-full transition-all duration-300 hover:scale-105 hover:shadow-2xl"
            style={{
              background: GOLD,
              color: PRIMARY,
              boxShadow: `0 8px 32px ${GOLD}55`,
            }}
          >
            <AutoAwesome style={{ fontSize: 16 }} />
            Become a Member
            <AutoAwesome style={{ fontSize: 16 }} />
          </button>

          <p
            className="font-abel text-xs mt-4"
            style={{ color: "rgba(255,255,255,0.35)" }}
          >
            Free to join · Open to all
          </p>
        </div>
      </section>
    </Fragment>
  );
};
